<template>
  <v-card class="elevation-0" :loading="loading" :disabled="loading">
    <v-card-title>Connexion à votre compte</v-card-title>
    <v-card-text>
      <v-container>
        <v-alert type="error" v-if="error">{{error}}</v-alert>
        <v-form @keyup.native.enter="connect()">
          <v-row>
            <v-text-field
              placeholder="Email"
              hide-details="auto"
              :rules="emailRules"
              v-model="model.email"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              placeholder="Mot de passe"
              type="password"
              hide-details="auto"
              :rules="passwordRules"
              v-model="model.password"
            ></v-text-field>
          </v-row>
          <v-row class="mt-3">
            <v-spacer />
            <v-btn small color="primary" @click="connect()" class="themed">Se connecter</v-btn>
          </v-row>
          <v-row>
            <p>
              Vous n'avez pas encore de compte?
              <a href="#" @click="$emit('subscribe')">créez-le ici!</a>
            </p>
          </v-row>
          <v-row>
            <p>
              <a href="#" @click="$emit('reset')">Mot de passe oublié?</a>
            </p>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: function() {
    return {
      error: null,
      emailRules: [
        value => !!value || "Champ obligatoire.",
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Adresse e-mail invalide.";
        }
      ],
      passwordRules: [
        value => !!value || "Champ obligatoire.",
        value =>
          (value || "").length >= 6 ||
          "Le mot de passe doit avoir au moins 6 charactères"
      ],
      model: {
        email: null,
        password: null
      }
    };
  },
  computed: {
    ...mapGetters("auth", ["loading"])
  },
  methods: {
    connect: function() {
      this.error = null;
      this.$store
        .dispatch("auth/login", this.model)
        .then(() => this.$router.push({ name: "Home" }))
        .catch(() => {
          this.error = "Email ou Mot de passe incorect";
        });
    }
  }
};
</script>